export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-orange-500 to-yellow-500 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4 md:mb-6">
            </div>
            <div className="space-y-2 md:space-y-3">
              {[
                { icon: 'ri-body-scan-line', text: '아이들의 신체를 건강하게 키우는 체육 교육' },
                { icon: 'ri-heart-line', text: '마음과 정서를 함께 성장시키는 인성 프로그램' },
                { icon: 'ri-lightbulb-line', text: '창의력과 융합 사고를 키우는 놀이 중심 수업' },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-start gap-2 md:gap-3 bg-white/15 rounded-lg px-3 md:px-4 py-2 md:py-3"
                >
                  <div className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center mt-0.5 shrink-0">
                    <i className={`${item.icon} text-white text-sm md:text-base`}></i>
                  </div>
                  <span className="text-xs md:text-sm text-white/95 leading-snug">{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-bold text-base md:text-lg mb-3 md:mb-4">빠른 링크</h4>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('brand')}
                  className="text-xs md:text-sm text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  브랜드 소개
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('categories')}
                  className="text-xs md:text-sm text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  주요 카테고리
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('programs')}
                  className="text-xs md:text-sm text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  교육 프로그램
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('facilities')}
                  className="text-xs md:text-sm text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  시설 안내
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-base md:text-lg mb-3 md:mb-4">프로그램</h4>
            <ul className="space-y-2 md:space-y-3">
              <li className="text-xs md:text-sm text-white/90">유아 창의체육</li>
              <li className="text-xs md:text-sm text-white/90">초등 창의체육</li>
              <li className="text-xs md:text-sm text-white/90">융합놀이</li>
              <li className="text-xs md:text-sm text-white/90">기본움직임 기술</li>
              <li className="text-xs md:text-sm text-white/90">특별 프로그램</li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-base md:text-lg mb-3 md:mb-4">연락처</h4>
            <ul className="space-y-2 md:space-y-3">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-xs md:text-sm flex-shrink-0"></i>
                <span className="text-xs md:text-sm text-white/90">010-9501-5908</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-xs md:text-sm flex-shrink-0"></i>
                <span className="text-xs md:text-sm text-white/90 break-all">newwavecompany@daum.net</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-xs md:text-sm mt-1 flex-shrink-0"></i>
                <span className="text-xs md:text-sm text-white/90">서울특별시 강남구 선릉로132길 28</span>
              </li>
            </ul>

            <div className="flex gap-2 md:gap-3 mt-4 md:mt-6">
              <a
                href="https://www.instagram.com/thinkgym2024/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 md:w-10 md:h-10 bg-white rounded-full flex items-center justify-center hover:opacity-80 transition-opacity cursor-pointer overflow-hidden"
                title="인스타그램"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/600px-Instagram_icon.png"
                  alt="Instagram"
                  className="w-7 h-7 md:w-8 md:h-8 object-contain"
                />
              </a>
              <a
                href="https://blog.naver.com/think_gym"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 md:w-10 md:h-10 bg-white rounded-full flex items-center justify-center hover:opacity-80 transition-opacity cursor-pointer overflow-hidden"
                title="네이버 블로그"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Naver_Logotype.svg/800px-Naver_Logotype.svg.png"
                  alt="Naver"
                  className="w-6 h-6 md:w-7 md:h-7 object-contain"
                />
              </a>
              <a
                href="https://youtube.com/channel/UCyXrpEpVecUyqGNsJN9V0dA?si=XSgJouQ9UOm-V4fi"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 md:w-10 md:h-10 bg-white rounded-full flex items-center justify-center hover:opacity-80 transition-opacity cursor-pointer overflow-hidden"
                title="유튜브"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/YouTube_full-color_icon_%282017%29.svg/800px-YouTube_full-color_icon_%282017%29.svg.png"
                  alt="YouTube"
                  className="w-7 h-7 md:w-8 md:h-8 object-contain"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-6 md:pt-8">
          <p className="text-xs md:text-sm text-white/80 text-center">
            © 2025 씽크짐창의융합놀이센터. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
